module.exports = __webpack_public_path__ + "img/92121.b3af977d.svg";